export enum IframeMessageToParentType {
  error = 'ERROR',
  requestAuth = 'REQUEST_AUTH',
  success = 'SUCCESS'
}
